import Typography from '@mui/material/Typography';

import { BasicServiceClass } from '~hooks/useServiceClass/models';
import { paletteColorStyles } from '~utils/colors';

interface ServiceClassChipProps {
  serviceClass: BasicServiceClass;
}

export default function ServiceClassChip({ serviceClass }: ServiceClassChipProps) {
  return (
    <Typography
      component="span"
      sx={{
        ...paletteColorStyles(serviceClass.color),
        borderRadius: '4px',
        fontSize: 'inherit',
        fontWeight: 600,
        px: 0.5,
      }}
    >
      {serviceClass.name}
    </Typography>
  );
}
